//React
import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as communityKeywordAction from '../action/communityKeywordAction';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

//Part
import MenuCommunity from './MenuCommunity';
//Dialog
import DialogCommunityKeywordUserList from './DialogCommunityKeywordUserList';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from '@material-ui/icons/Close';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keywordSearchWord: '',
      keywordAddText: null,
  	}
  }

  componentDidMount() {
    document.title = 'みんなのキーワード - パートナーズ';
    if ( ((new Date()) - this.props.communityKeyword.datetime) > (86400*1000) ) {
      this.props.communityKeywordPopListGet();
    }
  }

  _keywordSearchWordEdit(value) {
    this.setState({keywordSearchWord: value});
  }

  _keywordSearchWordSubmit(keyword) {
    this.props.communityKeywordSearchListGet(keyword.trim());
  }

  _keywordUserListOpen(keyword) {
    this.props.communityKeywordUserListGet(keyword, 1, Math.floor((new Date()).getTime() / 1000))
  }



	render() {

		return (
      <div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <MenuCommunity />
        </div>

        <div style={{maxWidth:'600px', margin:'auto'}} id='keyword_list_block'>

          <div style={{maxWidth:'320px', margin:'auto'}}>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                textAlign:'center',
                alignItems:'center',
                justifyContent:'space-between',
                padding:'10px'
              }}
            >
              <input
                style={{fontSize:'1.2em'}}
                className="input_blue round12"
                value={this.state.keywordSearchWord}
                placeholder="キーワード検索"
                maxLength={20}
                onChange={(e) => this._keywordSearchWordEdit(e.target.value)}
              />

              <div style={{width:'100px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => this._keywordSearchWordSubmit(this.state.keywordSearchWord) }
                  disabled={ (this.state.keywordSearchWord.length > 0) ? false: true }
                >
                  <span style={{fontSize:'1.2em'}}>検索</span>
                </Button>
              </div>
            </div>
          </div>



          {
            (this.props.communityKeyword.searchList.length > 0) ? (
              <div style={{padding:'10px'}}>
                {
                  this.props.communityKeyword.searchList.map(
                    (value, index, arr) => {
                      return (
                        <span key={index}>
                          <Button
                            variant="outlined"
                            style={{margin:'5px', textTransform: 'none'}}
                            endIcon={<KeyboardArrowDownIcon />}
                            onClick={ () => this._keywordUserListOpen(value.keyword_text) }
                          >
                            { value.keyword_text }
                          </Button>
                        </span>
                      )
                    }
                  )
                }
                <IconButton
                  onClick={ () => {
                    this.props.communityKeywordSearchListInit();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            ): (
              null
            )
          }
          <div style={{padding:'10px'}}>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <h2>人気キーワード</h2>
              </div>
              <div>
                <IconButton
                  onClick={ () => {
                    if ( ((new Date()) - this.props.communityKeyword.datetime) > (10*1000) ) {
                      this.props.communityKeywordPopListGet();
                    }
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </div>
            </div>

            {
              this.props.communityKeyword.popList.map(
                (value, index, arr) => {
                  return (
                    <span key={index}>
                      <Button
                        variant="outlined"
                        style={{margin:'5px', textTransform: 'none'}}
                        endIcon={<KeyboardArrowDownIcon />}
                        onClick={ () => this._keywordUserListOpen(value.keyword_text) }
                      >
                        { value.keyword_text }
                      </Button>
                    </span>
                  )
                }
              )
            }
          </div>

          <div style={{padding:'10px'}}>
            {
              (this.props.my.keyword.length > 0) ? (
                <>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <h2>マイキーワード</h2>
                    </div>
                    <div>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={ () => this.props.history.push('/my/keyword/') }
                      >
                        編集
                      </Button>
                    </div>
                  </div>
                  {
                    this.props.my.keyword.map(
                      (value, index, arr) => {
                        return (
                          <span key={index}>
                                <Button
                                  variant="outlined"
                                  style={{margin:'5px', textTransform: 'none'}}
                                  endIcon={<KeyboardArrowDownIcon />}
                                  onClick={ () => this._keywordUserListOpen(value.text) }
                                >
                                  { value.text }
                                </Button>
                          </span>
                        )
                      }
                    )
                  }
                </>
              ): (
                null
              )
            }
          </div>
        </div>

        <DialogCommunityKeywordUserList
          open={(this.props.communityKeyword.userList.length > 0) ? true : false}
          close={ () => this.props.communityKeywordUserListInit() }
        />
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		communityKeyword: state.communityKeyword,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...communityKeywordAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
